import "./widgetSm.css";
import { FiEye } from "react-icons/all";
import React,{ useState, useEffect } from "react";
import { getUsers } from "../../Data/Users";

export default function WidgetSm() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const allUsers = getUsers();
      setUsers(
        (await allUsers).docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );
    };
    return fetchUsers();
  }, []);

  return (
    <div className="widgetSm">
      <span className="widgetSmTitle">Total Registered Customers</span>
      <h3 style={{fontSize: "50px", color:"green"}}>
      
        <center>{users.length}</center>
      </h3>
    </div>
  );
}
